export const desktopNavigationQuery = "(min-width: 1024px)";

export function getVisibleTestimonialCount(isMobile: boolean) {
  return isMobile ? 1 : 3;
}

export function shouldAnimateSocialProof(
  isMobile: boolean,
  prefersReducedMotion: boolean,
) {
  return !isMobile && !prefersReducedMotion;
}
